module.exports = __webpack_public_path__ + "img/success_bg.88fdc69c.png";